import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react'

export const LoadingWarningContext: React.Context<LoadingWarningProvider> =
  createContext<LoadingWarningProvider>({
    showLoadingWarning: false,
    setShowLoadingWarning: async () => {
      return false
    },
  })

export const ProvideLoadingWarning = ({
  children,
}: React.PropsWithChildren<any>): React.ReactElement => {
  const showLoadingWarning: LoadingWarningProvider = useProvideLoadingWarning()
  return (
    <LoadingWarningContext.Provider value={showLoadingWarning}>
      {children}
    </LoadingWarningContext.Provider>
  )
}

export const useLoadingWarning = (): LoadingWarningProvider => {
  return useContext<LoadingWarningProvider>(LoadingWarningContext)
}

export interface LoadingWarningProvider {
  showLoadingWarning?: boolean
  setShowLoadingWarning: Dispatch<SetStateAction<boolean>>
}

export const useProvideLoadingWarning = (): LoadingWarningProvider => {
  const [showLoadingWarning, setShowLoadingWarning] = useState<boolean>(false)

  return {
    showLoadingWarning,
    setShowLoadingWarning,
  }
}
